"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetTopFiveElectricalEnergyUsage = void 0;
const react_1 = require("react");
const useBranchEnergyCalculation_1 = require("./useBranchEnergyCalculation");
const MAXIMUM_DEVICE_COUNT = 5;
const useGetTopFiveElectricalEnergyUsage = ({ selectedHub, sensors, }) => {
    const { branchEnergyCalculationData } = (0, useBranchEnergyCalculation_1.useBranchEnergyCalculation)({ selectedHub, sensors });
    const [devices, setDevices] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        const filteredDevices = branchEnergyCalculationData
            .map((entry) => {
            const name = entry.name;
            return {
                name,
                value: Number(entry.percent),
                power: Number(entry.power),
            };
        })
            .sort((first, second) => second.value - first.value)
            .slice(0, MAXIMUM_DEVICE_COUNT);
        setDevices(filteredDevices);
    }, [branchEnergyCalculationData]);
    return {
        devices,
        getTopFiveDevices: () => devices,
    };
};
exports.useGetTopFiveElectricalEnergyUsage = useGetTopFiveElectricalEnergyUsage;
